export {
  type SeedAllStudiedActorDeckResult,
  useSeedAllStudiedActorDeck,
} from "#use-seed-all-studied-actor-deck";
